import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface TabProps {
  tab: Record<string, any>;
  onClick: (tab: any) => void;
  defaultTab?: string;
  disabled?: boolean;
}

export const Tab = ({
  tab,
  onClick,
  defaultTab,
  disabled = false
}: TabProps) => {
  const [activeTab, setActiveTab] = useState<string>(defaultTab || '');

  useEffect(() => {
    setActiveTab(defaultTab || '');
  }, [defaultTab]);

  return (
    <Container>
      {Object.entries(tab).map(([key, value]) => {
        return (
          <StyledTab
            active={activeTab === key}
            onClick={() => {
              if (disabled) return;
              setActiveTab(key);
              onClick(value);
            }}
            key={key}
          >
            {key}
          </StyledTab>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 8px;
`;

const StyledTab = styled.div<{ active: boolean }>`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border: 1px solid
    ${({ active }) =>
      active ? 'var(--Brand-400, #7750e9)' : 'var(--bg-700, #262231)'};
  border-radius: 8px;
  background: var(--bg-600, #2e2a3a);
`;
